import { Injectable } from '@angular/core';
declare let LZString: any;
@Injectable()
export class LZservice {
  constructor() {
    /**/
  }
  public Compress(data: any): string {
    return LZString.compressToUTF16(data);
  }
  public DecompressFromUTF16(input: string): any {
    return LZString.decompressFromUTF16(input);
  }
}
